import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EChartsChartZoomToolbar = _resolveComponent("EChartsChartZoomToolbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'echarts-chart-zoom': _ctx.enabled })
  }, [
    (_ctx.enabled)
      ? (_openBlock(), _createBlock(_component_EChartsChartZoomToolbar, {
          key: 0,
          zoomApi: _ctx.zoomApi
        }, null, 8, ["zoomApi"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {
      withZoom: _ctx.withZoom,
      bindVChart: _ctx.bindVChart
    }, undefined, true)
  ], 2))
}